import FeatureFlagService from '@/services/FeatureFlagService'

export default {
  namespaced: true,
  state: {
    flags: {},
    companyIds: []
  },
  getters: {
    isEnabled: (state) => (id) => {
      if (!Object.keys(state.flags).length) return

      // OBS resolves each flag to a boolean for the active company
      return state.flags[id] === true
    },
    isEnabledV2: (state, _, rootState) => (id) => {
      if (!Object.keys(state.flags).length) return false
      const flag = state.flags[id]
      if (!flag) return false

      // /ff endpoint flattens flags to a boolean for the resolved viewer
      if (flag === true) return true

      // check if company is enabled
      if (Array.isArray(flag)) {
        return state.companyIds.some((companyId) => flag.includes(companyId))
      }

      // check if enabled for all
      if (flag.enabled === true) return true

      // check if user enabled
      const user = rootState.user.onlineUser
      if (flag.users?.length && flag.users.includes(user._id)) return true

      return false
    }
  },
  mutations: {
    setCompanies(state, companyIds) {
      state.companyIds = [...companyIds]
    },
    setFeatureFlags(state, data) {
      state.flags = { ...data }
    }
  },
  actions: {
    setFeatureFlagCompanies({ commit, dispatch, state }, companyIds) {
      const switched =
        companyIds.length &&
        state.companyIds.length &&
        companyIds.join() !== state.companyIds.join()
      commit('setCompanies', companyIds)
      if (switched) dispatch('getFeatureFlags')
    },
    async getFeatureFlags({ commit, state }) {
      const companyIds = state.companyIds
      try {
        const response = await FeatureFlagService.list(
          companyIds.length === 1 ? companyIds[0] : undefined
        )
        if (state.companyIds.join() !== companyIds.join()) return
        commit('setFeatureFlags', response.data.data)
      } catch (e) {
        // fail closed so the previous company's flags never linger
        if (state.companyIds.join() === companyIds.join()) commit('setFeatureFlags', {})
      }
    }
  }
}
